import { render, staticRenderFns } from "./AssingCompany.vue?vue&type=template&id=21a9d340&scoped=true&"
import script from "./AssingCompany.vue?vue&type=script&lang=js&"
export * from "./AssingCompany.vue?vue&type=script&lang=js&"
import style0 from "./AssingCompany.vue?vue&type=style&index=0&id=21a9d340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9d340",
  null
  
)

export default component.exports